export default "__VITE_ASSET__B37tzg95__"